export default class FontResizer {
    constructor(elm) {
        const property = '--main-menu-font-size';
        const spaceToTheRight = 105;
        const baseValue = 1;
        const pxToIncrease = 200;
        let currentValue = baseValue;
        const increment = 0.125;
        function resize() {
            const offsetRight = window.innerWidth - elm.lastElementChild.getBoundingClientRect().right;
            if (offsetRight < spaceToTheRight && currentValue > increment) {
                currentValue -= increment;
                elm.style.setProperty(property, currentValue + 'rem');
                resize();
            } else if (offsetRight > (pxToIncrease + spaceToTheRight) && baseValue > currentValue) {
                currentValue += increment;
                elm.style.setProperty(property, currentValue + 'rem');
                resize();
            }
        }

        resize();
        window.addEventListener('resize', resize);
    }
}
